<div class="contract-duration">
  <div class="duration-description">
    {{ getDurationDescription() | async }}
  </div>
  <ng-container *ngIf="!includesUndefinedPricing && !isFree()">
    <div class="duration-total">
      <span class="total-label">
        {{ 'FRONTEND.STORE.ESTIMATED_VALUE' | translate }}
      </span>
      <div class="duration-col">
        <ng-container *ngFor="let durationPrice of calculatePriceForDuration()">
          <ng-container *ngIf="durationPrice.total > 0">
            <div class="duration-row">
              <strong>
                <billing-ui-simple-price-display
                  [price]="(durationPrice.total || 0) * 100"
                  [currencyCode]="durationPrice.currencyCode"
                  [frequency]="Frequency.ONE_TIME"
                  [topLabel]="durationPrice.startingPrice ? 'starting-at' : undefined"
                ></billing-ui-simple-price-display>
              </strong>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </ng-container>
</div>
